import { toast } from './toast';
import { useToastProps } from './types';

/**
 * Returns the imperative Toast API — `notify`, the `success` / `error` /
 * `warning` / `info` / `loading` variants, `promise`, `update` and `dismiss`.
 * The object is a stable singleton, so it is safe in a dependency array.
 *
 * Outside a component, import `toast` instead: it is the very same API.
 *
 * @example
 * const { success, error } = useToast();
 * success({ content: 'Changes saved' });
 * error({ title: 'Error', content: 'Failed to save' });
 */
export const useToast: useToastProps = () => toast;
